import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { useQuery } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { useNotification } from 'src/providers/notificationsProvider';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { getContentById } from 'src/services/napi';

const fetchContent = async (contentId: string) => {
  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );
  if (!currentProject) return;

  const data = await getContentById(contentId, currentProject._id);
  return data;
};

export const useGetContentQuery = (contentId: string) => {
  const { notify } = useNotification();

  return useQuery([QueryKey.CONTENT, contentId], () => fetchContent(contentId), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    }
  });
};
